import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = []

    connect() {
        this.frameLoadHandler = (event) => this.handleFrameLoad(event);
        this.streamRenderHandler = (event) => this.handleStreamRender(event);
        this.animationStyles = new WeakMap();

        document.addEventListener("turbo:frame-load", this.frameLoadHandler);
        document.addEventListener("turbo:before-stream-render", this.streamRenderHandler);
    }

    disconnect() {
        if (this.frameLoadHandler) {
            document.removeEventListener("turbo:frame-load", this.frameLoadHandler);
        }
        if (this.streamRenderHandler) {
            document.removeEventListener("turbo:before-stream-render", this.streamRenderHandler);
        }
    }

    handleStreamRender(event) {
        requestAnimationFrame(() => this.handleFrameLoad(event))
    }

    handleFrameLoad(event) {
        if (!window.M) return;

        requestAnimationFrame(() =>
            this.withSuppressedAnimations(event.target, (element) => {
                this.reInitializeMaterializeCss(element);
            }));
    }

    withSuppressedAnimations(element, callback) {
        const style = this.suppressAnimations(element);
        try {
            callback(element);
        } finally {
            this.reEnableAnimations(element, style);
        }
    }

    suppressAnimations(element) {
        if (!element?.id) return null;

        const style = document.createElement('style');
        style.textContent = `
            #${element.id}.no-animations * {
                transition: none !important;
                animation: none !important;
                animation-duration: 0s !important;
                transition-duration: 0s !important;
            }
        `;
        document.head.appendChild(style);
        element.classList.add('no-animations');

        this.animationStyles.set(element, style);
        return style;
    }

    reEnableAnimations(element, style) {
        if (!element || !style) return;

        element.classList.remove('no-animations');
        if (style.parentNode) {
            document.head.removeChild(style);
        }
        this.animationStyles.delete(element);
    }

    reInitializeMaterializeCss(element) {
        if (!element) return;

        /**
         * The turbo-stream response contains a <template> element, and content inside <template> tags is
         * inert - it's not part of the active DOM and won't be found by querySelector or querySelectorAll.
         *
         * This is the fix for modal2_component
         */
        const template = element.querySelector('template'); // turbo-stream returns a dom-template
        if (template) {
            const template_element_id = template.content.querySelector('[id]')?.id
            if (template_element_id !== undefined) {
                const element = document.getElementById(template_element_id);
                return this.reInitializeMaterializeCss(element);
            }
        }

        // Initialize all select elements
        const selects = element.querySelectorAll('select');
        if (selects.length > 0) {
            M.FormSelect.init(selects);
            // add `filled-in` css class
            document
                .querySelectorAll('.dropdown-content input[type="checkbox"]')
                .forEach(checkbox => checkbox.classList.add("filled-in"));
        }

        // Initialize all datepickers
        this.initializeComponent(element, '.datepicker', M.Datepicker);

        // Initialize all timepickers
        this.initializeComponent(element, '.timepicker', M.Timepicker);

        // Update text fields (for floating labels)
        M.updateTextFields();


        const textareas = element.querySelectorAll('textarea');
        // Initialize textareas (with character counter)
        // this should work, but if not -> textareas.forEach(a => this.textareaAutoResize($(a)));
        if (textareas.length > 0) {
            textareas.forEach(textArea => M.textareaAutoResize(textArea));
            M.CharacterCounter.init(element.querySelectorAll('input[data-length], textarea[data-length]'));
        }

        // Initialize tooltips
        this.initializeComponent(element, '.tooltipped', M.Tooltip);
    }

    initializeComponent(element, selector, component) {
        const elements = element.querySelectorAll(selector);
        if (elements.length > 0) {
            component.init(elements);
        }
    }

}